import React, { useState } from "react";
import PropTypes from "prop-types";
import InlineError from "../InlineError";
import "./style.scss";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const GlobalDropDown2 = (props) => {
  const {
    containerStyle,
    label,
    required,
    options,
    onChange,
    selectTagStyle,
    name,
    value,
    onBlur,
    hasInvalidSubmitOccurred,
    error,
    disabled,
    containerClass,
    defaultOptionText,
    defaultOptionDisable,
    placeholder,
    type,
    ...rest
  } = props;

  const [touched, setTouched] = useState(false);

  const handleBlur = (e, name) => {
    setTouched(true);
    if (onBlur) {
      onBlur(e, name);
    }
  };
  const truncate = (str) =>
    str && str.length > 60 ? `${str.substring(0, 59)}...` : str;

  const displayError = touched || hasInvalidSubmitOccurred;

  return (
    <div
      className={`global-select ${containerStyle} ${containerClass} ${
        displayError && error ? "error" : ""
      }`}
    >
      {/* {label && (
        <label htmlFor="">
          {label}
          {required && <span className="required">&nbsp;*</span>}
        </label>
      )} */}
      {/* <InputLabel>{label}</InputLabel> */}
      <FormControl fullWidth>
        <InputLabel labelWidth={label.length * 9}>{label}</InputLabel>

        <Select
          name={name}
          className={selectTagStyle}
          onChange={(e) => onChange(e, name)}
          onBlur={(e) => handleBlur(e, name)}
          value={value ? value : ""}
          disabled={disabled}
          // placeholder={placeholder}
          label={label}
          // labelWidth={label.length * 9}
          {...rest}
        >
          <MenuItem value="">
            {defaultOptionText ? defaultOptionText : "Select Value"}
          </MenuItem>
          {options &&
            options.length > 0 &&
            options.map((val, index) => {
              return (
                <MenuItem
                  key={
                    type === "Country" || type === "State"
                      ? val?.isoCode
                      : label + index
                  }
                  label={
                    type === "Country" || type === "State"
                      ? val?.name
                      : val.value
                  }
                  value={
                    type === "Country" || type === "State"
                      ? val?.isoCode
                      : val.value
                  }
                >
                  {type === "Country" || type === "State"
                    ? val?.name
                    : val.value}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      {displayError && error && <InlineError message={error} />}
    </div>
  );
};

GlobalDropDown2.propTypes = {
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  hasInvalidSubmitOccurred: PropTypes.bool,
  containerStyle: PropTypes.string,
  selectTagStyle: PropTypes.string,
  defaultOptionDisable: PropTypes.bool,
};

GlobalDropDown2.defaultProps = {
  disabled: false,
  value: "",
  error: "",
  onChange: () => {},
  label: "",
  required: false,
  name: "",
  containerStyle: "",
  onBlur: () => {},
  hasInvalidSubmitOccurred: false,
  selectTagStyle: "",
  defaultOptionDisable: false,
};
export default GlobalDropDown2;
